/**
 * @generated SignedSource<<02b4debc524230df22d9a6426089c256>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableRateEditorForm_data$data = {
  readonly previewRoomRate?: {
    readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorPriceBreakdown_roomRate">;
  };
  readonly " $fragmentType": "RoomRatesTableRateEditorForm_data";
};
export type RoomRatesTableRateEditorForm_data$key = {
  readonly " $data"?: RoomRatesTableRateEditorForm_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateEditorForm_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "input"
    },
    {
      "kind": "RootArgument",
      "name": "packageDateId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "preview"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": require('./RoomRatesTableRateEditorFormQuery.graphql')
    }
  },
  "name": "RoomRatesTableRateEditorForm_data",
  "selections": [
    {
      "condition": "preview",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "input",
              "variableName": "input"
            },
            {
              "kind": "Variable",
              "name": "packageDateId",
              "variableName": "packageDateId"
            }
          ],
          "concreteType": "RoomRate",
          "kind": "LinkedField",
          "name": "previewRoomRate",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RoomRatesTableRateEditorPriceBreakdown_roomRate"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "65c043bf3d48bebf728e1843d007c201";

export default node;
